import { Grid, Typography } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";

export enum UserExperienceAdequacyMessage {
  AdequacyEvaluationNotPossible,
  NotAdequate,
}

export const UserExperienceAdequacyMessageSubform = ({ view = UserExperienceAdequacyMessage.AdequacyEvaluationNotPossible } : any) => {
  // Hooks
  const { t } = useTranslation();

  return (
    <Grid
      justify="center"
      className="common-notice-container"
      direction="column"
      spacing={2}
      container
    >
      {view === UserExperienceAdequacyMessage.AdequacyEvaluationNotPossible &&
      <Grid item>
        <Typography className="common-notice-paragraph">
          {t(`Dear Customer,`)}
        </Typography>

        <Typography className="common-notice-paragraph">
          {t(`Adequacy is assessed on the basis of whether you, as an investor, have the necessary knowledge and experience to adequately assess the risks associated with the type of financial instruments or investment services.`)}
        </Typography>

        <Typography className="common-notice-paragraph">
          {t(`In the documents you returned you provided incomplete or essentially no information about your previous experience and knowledge in connection with securities transactions. As a result, we are unable to fulfill our duty to assess the adequacy of the investment.`)}
        </Typography>

        <Typography className="common-notice-paragraph">
          {t(`We therefore urge you to note that an assessment of adequacy is not possible in the case of missing/incomplete information. You must therefore decide for yourself whether the securities are adequate for you or not. In particular, you should familiarize yourself with the risks and specifics of the securities. A detailed description of the risks associated with the subscription can be found in the section "Risk Factors" of the prospectus relevant to the respective offering.`)}
        </Typography>

        <Typography className="common-notice-paragraph">
          {t(`Should you nevertheless wish to refrain from subscribing, you may exercise your 14-day right of withdrawal.`)}
        </Typography>
      </Grid>
      }

      {view === UserExperienceAdequacyMessage.NotAdequate &&
      <Grid item>
        <Typography className="common-notice-paragraph">
          {t(`The evaluation of the information provided by you regarding previous knowledge and experience with securities/investments/capital market products revealed that the product offered here or the amount of your subscription does not correspond to the investment profile drawn up on the basis of the information you have provided. According to the information you have provided, you do not have sufficient knowledge and experience to adequately assess the risks associated with the purchase of the product offered here, i.e. your subscription does not correspond to your previous investment profile.`)}
        </Typography>

        <Typography className="common-notice-paragraph">
          {t(`Please refer to the sales prospectus you have been provided with, or alternatively the other documents about the design and risk structure of the product. Your broker will of course be happy to discuss the matter with you again. If you nevertheless decide to subscribe to the product, we ask you to confirm this decision in a legally binding manner`)}
        </Typography>

        <Typography className="common-notice-paragraph">
          {t(`I am informed that the subscription of the capital investment does not correspond to my investment profile based on my stated knowledge and previous experience with securities, investments and other capital market products. I nevertheless decide to subscribe to the following capital investment for the amount stated above.`)}
        </Typography>
      </Grid>
      }
    </Grid>
  );
};
